module.exports = __webpack_public_path__ + "img/white_paper10.6d38d3ad.png";